import { render, staticRenderFns } from "./lang-selector.vue?vue&type=template&id=5fb5347f&"
import script from "./lang-selector.vue?vue&type=script&lang=ts&"
export * from "./lang-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports